import { create } from "zustand";
import { BenefitsById } from "../utils/Benefits";

interface UserData {
  isIndexer: boolean;
  isTagger: boolean;
  email: string;
  user_id: string;
  created_at: string;
  userDataId: string;
  isApprover: boolean;
  isCurator: boolean;
  // Curates the featured scripts list and nothing else. Implied by isApprover.
  isFeatureAdmin: boolean;
  isActive: boolean;
  isBlacklisted: boolean;
  patreon_linked: boolean;
  patreon_ever_linked?: boolean;
  // Campaign tier from Patreon. Layer 2 only applies if this id is in the matrix.
  patreon_tier_id?: string | null;
  // Already-resolved values from the database helper (local, else Patreon, else default).
  benefits?: BenefitsById | null;
}

interface UserState {
  data?: UserData;
  loading?: boolean;
  setUserData: (userData: UserData | null) => void;
  setLoading: (loading: boolean) => void;
  isLoggedIn: () => boolean;
}

const userStore = create<UserState>()((set, get) => ({
  data: null,
  loading: true,
  setUserData: (userData: UserData | null) => set({ data: userData, loading: false }),
  setLoading: (loading) => set({ loading }),
  isLoggedIn: () => get().data !== null,
}));

export default userStore;
